import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

export const LoadingHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  border-bottom: ${(props) => (props.showUnderline ? `0.1rem solid ${colors.lightGray11}` : 'none')};
`;

export const ResultsColumn = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  word-break: break-all;
  display: flex-inline;
  align-items: center;
  padding-right: 10px;
  font-size: 12px;
  width: ${(props) => props.width || 'auto'};
`;

export const ResultsColumnGrey = styled(ResultsColumn)`
  color: #707b90;
`;

export const ReturnColumn = styled(ResultsColumn)`
  width: 40%;
`;

export const ReturnColumnGrey = styled(ResultsColumn)`
  color: #707b90;
  width: ${(props) => (props.width ? props.width : '30%')};
`;

export const ResultRowReturnItems = styled.div`
  display: flex;
  padding: 5px 0px;
`;

export const ResultRowReturnHeader = styled.div`
  display: flex;
  padding: 0px 0px 5px;
`;

export const ResultRowReturnItemsContainer = styled.div`
  border-bottom: 0.1rem solid ${colors.lightGray11};
  margin: 0px 0px 0px 27px;
  padding: 10px 0px;
`;

export const CheckBoxColumn = styled.div`
  display: flex-inline;
  align-items: center;
  margin-left: 8px;
  margin-right: 7px;
`;

export const Checkbox = styled.input`
  margin: 0 15px 0 15px !important;
  border-radius: 0px;
  stroke: black !important;
  stroke-width: 2px;
  &:hover {
    cursor: pointer;
  }
`;

export const ReturnPackageCheckbox = styled(Checkbox)`
  margin: 0px 15px 0px 0px !important;
`;

export const CheckboxItem = styled.input`
  margin: 0 15px 0 50px !important;
  border-radius: 0px;
  stroke: black !important;
  stroke-width: 2px;
  &:hover {
    cursor: pointer;
  }
`;

export const NoCheckboxPlaceholder = styled.div`
  margin: 0 15px 0 50px !important;
`;

export const ResultRowOrders = styled.div`
  width: 100%;
  color: ${(props) => (props.checked ? 'black' : '#707B90')};
  border-bottom: 1px solid ${colors.lightGray11};
  display: flex;
  padding: 17px 0;
  background-color: ${(props) => (props.markAsOrder ? '#edf3f7' : '#fff')};

  & td {
    padding: 8px;
    line-height: 1.42857;
    vertical-align: top;
  }
`;

export const ResultRowItems = styled.div`
  color: #000;
  border-bottom: 0px;
  display: flex;
  padding: 5px 0px;

  & td {
    padding: 8px;
    line-height: 1.42857;
    vertical-align: top;
  }
`;

export const ResultRowSubItems = styled.div`
  display: flex;
  margin-left: 40px;
  margin-top: 5px;
  align-items: center;
`;

export const ResultRowReturns = styled.div`
  padding: 5px 0px;
  margin: 0px 0px 0px 30px;
`;

export const ResultItemContainer = styled.div`
  padding: 10px 0px;
  background-color: ${(props) => (props.markAsOrder ? '#edf3f7' : '#fff')};
`;

export const ResultsHeaderColumn = styled.div`
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: ${(props) => (props.width ? props.width : '100%')};
  font-size: 9px;
  display: flex-inline;
  align-items: center;
  padding-right: 10px;
  color: #707b90 !important;
`;

export const ResultsHeaderRow = styled.div`
  padding: 8px 0px 8px 42px;
  line-height: 1.42857143;
  vertical-align: top;
  color: #707b90 !important;
  display: flex;
`;
